// ─── Statscore API Credentials ────────────────────────────────────────────────
export const STATSCORE_CLIENT_ID = '2720';

// ─── Sport IDs ────────────────────────────────────────────────────────────────
export const SPORT_ID_FOOTBALL = 5;

// ─── English Football 2025/26 ─────────────────────────────────────────────────
// Competition IDs (stable across seasons) and their current season IDs.
// Season IDs rotate each summer — update the seasonId values at the start of each season.
export const COMPETITIONS_2025_26 = {
    EPL:        { compId: 1528, seasonId: '65679' },
    UCL:        { compId: 1658, seasonId: '65991' },
    FA_CUP:     { compId: 1530, seasonId: '65990' },
    LEAGUE_CUP: { compId: 1748, seasonId: '65888' },
};

// Convenience array of all four season IDs for "All Competitions" queries.
export const ALL_COMPETITION_SEASON_IDS = Object.values(COMPETITIONS_2025_26).map(c => c.seasonId);

// Competition ID → short code. Stable — comp IDs never change across seasons.
// Used by seasons.js discovery and leaderboard.js to label participants by competition.
export const COMP_ID_TO_CODE = {
    1528: 'epl',
    1658: 'ucl',
    1530: 'fac',
    1748: 'lec',
};

// Season ID → short code for the current season. Derived from COMPETITIONS_2025_26.
// leaderboard.js uses this to tag each participant with the competition it came from.
export const SEASON_TO_COMP = {
    [COMPETITIONS_2025_26.EPL.seasonId]:        'epl',
    [COMPETITIONS_2025_26.UCL.seasonId]:        'ucl',
    [COMPETITIONS_2025_26.FA_CUP.seasonId]:     'fac',
    [COMPETITIONS_2025_26.LEAGUE_CUP.seasonId]: 'lec',
};

// ─── World Cup 2026 ───────────────────────────────────────────────────────────
export const WC_2026_SEASON_ID = 68411;
export const WC_2026_STAGE_ID = 147114;
// TODO: Switch back to 208357 once 2026 tournament data is live
export const WC_2026_GOLDEN_BOOT_STANDINGS_ID = 208357; // 2026 WC data
export const WC_2026_GROUP_STANDINGS_ID = 208339;
export const WC_2026_GROUP_IDS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

// ─── Default IDs ──────────────────────────────────────────────────────────────
/** Default event ID for fetchPlayerPositionStats */
export const DEFAULT_EVENT_ID = '5993471';

// ─── Stat IDs ─────────────────────────────────────────────────────────────────
export const STAT_IDS = {
    // Attacking
    XG: 1470,
    CHANCES_CREATED: 1480,
    SHOTS_ON_TARGET: 20,
    TOUCHES_IN_BOX: 940,
    /** Alternative Touches-in-Box ID — used for position-based filtering */
    TOUCHES_IN_BOX_ALT: 858,

    // Passing / Midfield
    PASS_ACCURACY: 1166,
    SUCCESSFUL_DRIBBLES: 1475,

    // Defensive
    INTERCEPTIONS: 487,
    TACKLES_WON: 32,
    TOTAL_TACKLES: 31,
    CLEARANCES: 1395,
    /** Clearances stat used for position-type filtering only */
    CLEARANCES_FILTER: 30,
    AERIAL_DUELS_WON: 33,
    TOTAL_AERIAL_DUELS: 1163,
    ERRORS_LEADING_TO_GOALS: 1473,

    // Goalkeeping
    SHOTS_SAVED: 29,
    IMPORTANT_SAVES: 1482,
    SPECTACULAR_SAVES: 1483,
    CLEAN_SHEETS: 1164,
    /** Clean sheets in a single-match / position-stats context */
    CLEAN_SHEETS_MATCH: 1162,

    // Performance
    RATING_SEASON: 1519,
    RATING_MATCH: 1518,

    // Volume
    APPEARANCES_SUB: 452,
    STARTS: 36,
    MINUTES_PLAYED: 34,
    GOALS: 40,
    ASSISTS: 41,
};
